<template>
  <div class="panel" id="time-travel">
    <div class="field">
      <label for="tt-date">Date</label>
      <input v-model="targetDate" id="tt-date" type="date" />
    </div>

    <div class="field">
      <label for="tt-time">Time</label>
      <input v-model="targetTime" id="tt-time" type="time" step="1" />
    </div>

    <div class="field">
      <label for="tt-zone">Timezone</label>
      <select id="tt-zone" v-model="targetTimeZone">
        <option value="America/New_York">America/New_York</option>
        <option value="America/Chicago">America/Chicago</option>
        <option value="America/Denver">America/Denver</option>
        <option value="America/Los_Angeles">America/Los_Angeles</option>
        <option value="UTC">UTC</option>
      </select>
    </div>

    <div class="field">
      <button id="tt-submit" :disabled="!isValid" @click="travel">
        Time Travel
      </button>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import { mapState } from 'vuex';
import { TIME_TRAVEL } from '../store/mutation-types';

export default {
  name: 'TimeTravel',

  data() {
    const now = DateTime.local();
    return {
      targetDate: now.toISODate(),
      targetTime: now.toFormat('HH:mm:ss'),
      targetTimeZone: now.zoneName,
    };
  },

  computed: {
    ...mapState(['time']),

    isValid() {
      return this.targetDate && this.targetTime && this.targetTimeZone;
    },
  },

  mounted() {
    // Initialize with current store time if available
    if (this.time && this.time.sinceEpoch && this.time.zone) {
      const dt = DateTime.fromMillis(this.time.sinceEpoch).setZone(
        this.time.zone,
        { keepLocalTime: true }
      );
      this.targetDate = dt.toISODate();
      this.targetTime = dt.toFormat('HH:mm:ss');
      this.targetTimeZone = this.time.zone;
    }
  },

  methods: {
    travel() {
      if (!this.isValid) {
        return;
      }

      // Compose ISO string and parse with Luxon
      const isoString = `${this.targetDate}T${this.targetTime}`;
      const dt = DateTime.fromISO(isoString, { zone: this.targetTimeZone });
      const sinceEpoch = dt.isValid ? dt.toMillis() : null;

      this.$store.commit(TIME_TRAVEL, {
        sinceEpoch,
        zone: this.targetTimeZone,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.panel {
  align-items: flex-end;
  background: #f8f8f8;
  border-radius: 0.3rem;
  color: #222;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  gap: 1rem;
  margin: 1rem auto 0.5rem;
  padding: 0.75rem 1rem;

  @include dark {
    background-color: #111;
    color: #aaa;
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  input,
  select {
    border: none;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 1.125rem;
    height: 2.25rem;

    @include dark {
      background-color: #eee;
      color: #555;
    }
  }
}

button {
  background: #00bba4;
  border-radius: 0.3rem;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  margin-top: 0.5rem;
  outline: none;
  padding: 0.65rem 1.5rem;
  transition: background 0.2s;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
